import Validator from '@shared/validatorjs/src/validator'
import { CreateFormRequest } from './../forms.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map, List } from 'immutable'
import { getCreateFormState } from '../forms.selectors'
import { SetDefaultData, UpdateField } from '../forms.actions'
import { FetchFormPostprocessorsRequest } from '@containers/form-postprocessors/form-postprocessors.actions'
import { getFormPostprocessorState } from '@containers/form-postprocessors/form-postprocessors.selectors'

@Component({
  selector: 'app-create-form',
  templateUrl: './create-form.component.html',
  styleUrls: ['./create-form.component.css'],
})
export class CreateFormComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public isDuplicate: boolean
  public postprocessors: any[] = []
  private postprocessors$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new FetchFormPostprocessorsRequest())
    this.state$ = this.store
      .pipe(select(getCreateFormState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.isDuplicate = state.get('isDuplicate')
      })

    this.postprocessors$ = this.store
      .pipe(select(getFormPostprocessorState))
      .subscribe((state) => {
        this.postprocessors = state.get('data')?.toJS()
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.store.dispatch<any>(new SetDefaultData('createForm'))
    this.postprocessors$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createForm.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createForm',
      ),
    )
  }

  onFormChange(rows: List<Map<string, any>>) {
    this.handleFieldChange(rows, 'form')
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event, redirect = true): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateFormRequest(payload, redirect))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createForm',
        ),
      )
    }
  }
}
